import { render, staticRenderFns } from "./ConfirmInstall.vue?vue&type=template&id=4d46adc0"
import script from "./ConfirmInstall.vue?vue&type=script&lang=js"
export * from "./ConfirmInstall.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports